<span class="showcase-creator d-flex" data-automation-id="showcase-creator">
  <span class="name mr-1">
    <fa-icon [icon]="creatorIcon" class="mr-1"></fa-icon>
    {{isCreator ? ('creatorMe' | translate) : creator || ('creatorUnknown' | translate)}}
  </span>
  <span class="label">
    {{'creator' | translate}}
  </span>
</span>
